import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Alert } from 'rsuite';
import { getSetupIpaBasicConfig } from '../../SetupIpaBasicConfig/service';
import { SupplierNegotiationConfigSchema } from '../SetupSupplierNegotiationConfig.schema';
import { postSupplierNegotiationConfig, putSupplierNegotiationConfig } from '../SetupSupplierNegotiationConfig.service';

const SUPPLIER_NEGOTIATION_CONFIG_QUERY_KEY = ['ipa.setup.basicConfig'] as const;

export const useSupplierNegotiationConfig = () => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: SUPPLIER_NEGOTIATION_CONFIG_QUERY_KEY,
    queryFn: getSetupIpaBasicConfig,
  });

  const mutation = useMutation({
    mutationFn: async (formData: SupplierNegotiationConfigSchema) => {
      if (query.data?.negotiation_cost) {
        return await putSupplierNegotiationConfig(formData);
      }

      return await postSupplierNegotiationConfig(formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUPPLIER_NEGOTIATION_CONFIG_QUERY_KEY });
      Alert.success('Configurações salvas com sucesso');
    },
    onError: () => {
      Alert.error('Erro ao salvar as configurações');
    },
  });

  return {
    data: query.data,
    saveSupplierNegotiationConfig: mutation.mutateAsync,
  };
};
